import React from "react";
import abus from "./images/abus.png";
import trading from "./images/trading.png";
import cabot from "./images/cabot.jpg";
import eurogoma from "./images/eurogoma.png";
import hayward from "./images/hayward.png";
import iconicon from "./images/iconicon.png";
import minelab from "./images/minelab.png";
import sepor from "./images/sepor.png";
import sepro from "./images/sepro.webp";
import norit from "./images/norit.png";

// Local partner logos — saved in public/images/partners/
const PARTNERS = [
  { name: "ABUS", logo: abus},
  { name: "Al Bayati Gen. Trading", logo: trading},
  { name: "Cabot", logo: cabot },
  { name: "Eurogomma", logo: eurogoma },
  { name: "Hayward Flow Control", logo: hayward },
  { name: "Icon Gold Recovery", logo: iconicon },
  { name: "Minelab", logo: minelab },
  { name: "SEPOR", logo: sepor },
  { name: "Sepro", logo: sepro },
  { name: "Norit Activated Carbon", logo: norit },
];

function Partners() {
  return (
    <>
      <section className="partners">
        <div className="partners-inner">
          {/* Heading */}
          <h2 className="partners-heading">
            We Have{" "}
            <span className="partners-heading-accent">
              International Partners
            </span>
          </h2>

          {/* Logo grid */}
          <div className="partners-grid">
            {PARTNERS.map((p, index) => (
              <div className="partners-card" key={index}>
                <img
                  src={p.logo}
                  alt={p.name}
                  loading="lazy"
                  onError={(e) => {
                    // hide broken images silently
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .partners {
          width: 100%;
          padding: 80px 40px;
          background: #ffffff;
          font-family: Arial, sans-serif;
          box-sizing: border-box;
        }

        .partners-inner {
          max-width: 1400px;
          margin: 0 auto;
        }

        /* ============ HEADING ============ */
        .partners-heading {
          font-size: 28px;
          font-weight: 800;
          letter-spacing: 0.3px;
          color: #111111;
          margin: 0 0 56px;
          line-height: 1.2;
          text-align: center
        }

        .partners-heading-accent {
          color: #b8965a;   /* warm gold */
        }

        /* ============ GRID ============ */
        .partners-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 30px 40px;
          align-items: center;
          justify-items: center;
        }

        /* ============ CARD ============ */
        .partners-card {
          width: 100%;
          max-width: 146px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.25s ease;
        }

        .partners-card img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          display: block;
          transition: all 0.25s ease;
        }

        /* Subtle lift + scale on hover */
        .partners-card:hover {
          transform: translateY(-4px);
        }
        .partners-card:hover img {
          transform: scale(1.05);
        }

        /* ============ RESPONSIVE ============ */
        @media (max-width: 1100px) {
          .partners-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 36px 30px;
          }
          .partners-heading {
            font-size: 30px;
            margin-bottom: 44px;
          }
        }

        @media (max-width: 800px) {
          .partners {
            padding: 60px 24px;
          }
          .partners-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 32px 24px;
          }
          .partners-heading {
            font-size: 26px;
            margin-bottom: 36px;
          }
          .partners-card {
            height: 80px;
            max-width: 180px;
          }
        }

        @media (max-width: 500px) {
          .partners {
            padding: 50px 20px;
          }
          .partners-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 28px 20px;
          }
          .partners-heading {
            font-size: 22px;
            margin-bottom: 32px;
          }
          .partners-card {
            height: 70px;
            max-width: 150px;
          }
        }
      `}</style>
    </>
  );
}

export default Partners;